import type { CustomFile } from '../types';

import { DEFAULT_CHUNK_SIZE } from './chunkConstants';
import prepareChunkedFile from './prepareChunkedFile';

// ----------------------------------------------------------------------------

export type TypeChunkedFile = {
    file: CustomFile;
    chunks: Blob[];
};

// ----------------------------------------------------------------------------

export function prepareChunkedFiles(files: CustomFile[], chunkSize: number = DEFAULT_CHUNK_SIZE): TypeChunkedFile[] {
    return files.map((file): any => ({
        file,
        chunks: prepareChunkedFile(file, chunkSize),
    }));
}

// ----------------------------------------------------------------------------

export default prepareChunkedFiles;
